import React, { useContext, useState, useEffect, useRef } from 'react';
import { useApiContext } from "../context/ApiContext.jsx";
import { AuthContext } from "../context/AuthContext.jsx";

const SplashScreen = ({ onClick }) => {
	const { sessionInfo } = useContext(AuthContext);
	const videoRef = useRef(null);

	useEffect(() => {
		if (videoRef.current) {
			videoRef.current.playbackRate = 0.8;
		}
	}, []);

	return (
		<div id="splash-screen" onClick={onClick} style={{ cursor: 'pointer' }}>
			{sessionInfo.template.splashBackgroundId ?
				<video
					ref={videoRef}
					autoPlay
					muted
					loop
					id="splash-video"
				>
					<source src={`/api/trivia/media/${sessionInfo.template.splashBackgroundId}`} type="video/mp4" />
				</video>
				: ""}

			<div className="splash-content">
				{sessionInfo.template.splashMascotteId ?
					<img src={`/api/trivia/media/${sessionInfo.template.splashMascotteId}`} id="splash-mascotte" />
					: ""}

				{sessionInfo.template.splashImageId ?
					<img
						src={`/api/trivia/media/${sessionInfo.template.splashImageId}`}
						alt="Logo Oleario Trivia"
						className="splash-logo animate__animated animate__fadeIn"
					/>
					: ""}
			</div>
			{/*<div className="meter animate">*/}
			{/*	<span style={{width: 0}}><span></span></span>*/}
			{/*</div>*/}
		</div>
	);
};

export default SplashScreen;
